import React, { useEffect, useState } from 'react';
import { HorizontalFlex, PadContainer } from 'smartsuite-ui';

function ButtonPanel({ system }) {
    const [icon, setIcon] = useState(null);

    useEffect(() => {
        async function fetchIcon() {
            try {
                const { default: icon } = await import(
                    `./images/${system.imageName}`
                );
                setIcon(icon);
            } catch (error) {
                console.error('Error loading icon', error);
                setIcon(null);
            }
        }
        fetchIcon();
    }, [system.imageName]);

    function displaySvgLogo(imageName) {
        if (icon) {
            return (
                <img
                    src={icon}
                    alt={imageName}
                    className="button-panel__logo"
                />
            );
        }

        return <span>{system.name}</span>;
    }

    let buttonClass =
        'button-div button-div--raised button-div--border button-div--margin-medium button-div--pad-small button-panel';

    if (system.isTestSystem) {
        buttonClass += ' button-panel--test-system';
    }

    return (
        <button
            className={buttonClass}
            onClick={() => window.open(system.url, '_blank')}
            type="button"
        >
            <HorizontalFlex
                cssClassModifiers={['small-relative', 'justify-center']}
            >
                {displaySvgLogo(system.imageName)}
            </HorizontalFlex>
            <PadContainer cssClassModifiers={['pad-medium']}>
                <div className="button-panel__system-name">
                    {system.systemName}
                </div>
            </PadContainer>
            {system.isTestSystem && (
                <span className="button-panel__test-icon fas fa-flask" />
            )}
        </button>
    );
}

export default ButtonPanel;
